module.exports = __webpack_public_path__ + "img/842.6a3b6984.b401af0f.svg";